export const DEFAULT_HALF_CARD_DATA = {
    titleV2: "Introducing Swiggy",
    subTextV2: "Powered by",
    iconUrlV2: "Swiggy%20UPI/Swiggy%20UPI%20logo%20vertical.png",
    ctaV2: "Activate in 10 seconds",
    subtitle: "Unlock 3x faster in-app UPI payment on Swiggy",
    lottiePath: "Swiggy%20UPI/swiggy%20upi%20new.json",
    subTextLogosUrl: "Swiggy%20UPI/Powered%20by.png",
};

export const HALF_CARD_TITLE_IMAGE = {
    width: 63,
    height: 19,
};

export const HALF_CARD_POWERED_BY_LOGOS_IMAGE = {
    height: 14,
    width: 171,
};
